<template>
  <div>
    <adaptive-modal />
    <sample-header> </sample-header>
    <loading-indicator message='Validating your code' v-if="!loaded"></loading-indicator>
    <div v-if="loaded" class="dynamic-content">
      <div v-html="marketingContent"></div>
      <button v-if="this.programChoice === 'RBAS1' || this.programChoice === 'RBAP1'"
        class="btn btn-submit create-order-button" @click="$modal.show('instructions')">View Order Instructions
      </button><br/>
      <button v-if="marketingContent.length > 0" class="btn btn-submit create-order-button" @click="navToOrder()">Create Your Order</button>
      
      <ContentFooter :couponCode="couponCode" :programChoice="programChoice" :hasError="hasError"></ContentFooter>

      <div v-if="hasError">
        <div v-html="errorMessage"> </div>
        <router-link to="/">Back to Home</router-link>
      </div>
    </div>
    <sample-footer> </sample-footer>
  </div>
</template>
<script>

import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
import ContentFooter from "@/components/marketing/ContentFooter";
import Vue from "vue";
import LoadingIndicator from "@/components/layout/LoadingIndicator";
import AdaptiveModal from "@/components/layout/InstructionsModal.vue";

let MSG_ServerError = `<p>We are unable to process this code at this time.  
Verify you are online and please try again later.  
If the problem persists please email our support team at 
<a href="mailto:Support@essilorsupport.com?subject=Error on site">Support@essilorsupport.com</a></p>
`;

let MSG_NoMatch = `The redemption code you have entered is incorrect. 
Please check it one more time. 
If you still get an error, please email our support team at 
<a href="mailto:Support@essilorsupport.com?subject=Invalid redemption code">Support@essilorsupport.com</a></p>
`;

let MSG_Redeemed = `Please check the redemption code you have entered. 
The code you have entered has already been used. 
Please email our support team at 
<a href="mailto:Support@essilorsupport.com?subject=Invalid redemption code">Support@essilorsupport.com</a></p>
`;

let MSG_Expired = `This redemption code is already expired. Please email our support team at 
<a href="mailto:Support@essilorsupport.com?subject=Redemption code expired">Support@essilorsupport.com</a></p>
`;

function interpretStatus(status) {
  switch (status) {
    case "NOT_FOUND":
      return MSG_NoMatch;
      break;

    case "REDEEMED":
      return MSG_Redeemed;
      break;

    case "EXPIRED":
      return MSG_Expired;
      break;
  }
}

export default {
  props: ["couponCode", "programChoice"],
  components: { SampleHeader, SampleFooter, LoadingIndicator, AdaptiveModal, ContentFooter },
  data() {
    return {
      marketingContent: "",
      hasError: false,
      loaded: false
    };
  },

  methods: {
    processCode(couponData) {
      if (couponData.programDetails.marketingPageName) {
        axios
          .get(
            Vue.config.HOST_URL + couponData.programDetails.marketingPageName,
            {
              responseType: "text"
            }
          )
          .then(response => {
            this.marketingContent = response.data;
            this.loaded = true;
          });
      } else {
        this.navToOrder();
      }
    },
    navToOrder() {
      if (this.programChoice) {
        this.$router.push(
          "/order/" + this.couponCode + "?programChoice=" + this.programChoice
        );
      } else {
        this.$router.push("/order/" + this.couponCode);
      }
    },
    applyError(msg) {
      this.hasError = true;
      this.errorMessage =
        "<div><h1>Unable to process this code</h1><p>" + msg + "</p></div>";
      this.loaded = true;
    },

    codeValid() {
      return (
        this.couponCode && this.couponCode.length === "xxxxx-xxx-xxx-xxx".length
      );
    },
    handleLoadError(error) {
      if (error.response && error.response.status == "404") {
        this.applyError(interpretStatus("NOT_FOUND"));
      } else {
        this.applyError(MSG_ServerError);
      }
    },
    loadCouponCodeWithProgramChoice() {
      axios
        .get(`/coupon/${this.couponCode}/programChoice/${this.programChoice}`)
        .then(response => {
          if (response && (response.data.programDetails.programType === "Employee" || response.data.programDetails.programType === "SalesRep")) {
            this.applyError(interpretStatus("NOT_FOUND"));
            return;
          }
          switch (response.data.status.statusCodeText) {
            case "":
              this.processCode(response.data);
              break;
            default:
              this.applyError(
                interpretStatus(response.data.status.statusCodeText)
              );
              break;
          }
        })
        .catch(error => {
          this.handleLoadError(error);
        });
    },
    loadCouponCodeWithoutProgramChoice() {
      axios
        .get("/coupon/" + this.couponCode)
        .then(response => {
          if (response && (response.data.programDetails.programType === "Employee" || response.data.programDetails.programType === "SalesRep")) {
            this.applyError(interpretStatus("NOT_FOUND"));
            return;
          }
          if (
            response.data.lensProgramChoices &&
            response.data.lensProgramChoices.length > 0 &&
            response.data.status.statusCodeText == ""
          ) {
            this.$router.push("/program_choice/" + this.couponCode);
            return;
          }
          switch (response.data.status.statusCodeText) {
            case "":
              this.processCode(response.data);
              break;
            default:
              this.applyError(
                interpretStatus(response.data.status.statusCodeText)
              );
              break;
          }
        })
        .catch(error => {
          this.handleLoadError(error);
        });
    },
    validateCode() {
      if (this.codeValid() && !this.programChoice) {
        this.loadCouponCodeWithoutProgramChoice();
      } else if (this.codeValid() && this.programChoice) {
        this.loadCouponCodeWithProgramChoice();
      } else {
        this.applyError(interpretStatus("NOT_FOUND"));
      }
    }
  },
  created() {
    this.validateCode();
  }
};
</script>
<style>
.create-order-button {
  margin-top: 25px;
  margin-bottom: 35px;
  width: 300px;
}
</style>
